import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentQuestionIndex: 0,
  questions: [],
  answers: [],
  timers: {},
  status: "idle",
  pauseflag: false
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    startSession(state, action) {
      state.questions = action.payload.questions;
      state.currentQuestionIndex = 0;
      state.answers = [];
      state.status = "in-progress";
      state.pauseflag = false;
  
      state.timers = {};
      action.payload.questions.forEach(q => {
        state.timers[q.id] = q.timeLimit;
      });
    },

    tickTimer(state, action) {
      const qid = action.payload;
      const currentQuestion = state.questions[state.currentQuestionIndex];
      
     
      if (
        currentQuestion &&
        currentQuestion.id === qid &&
        state.timers[qid] > 0 &&
        !state.pauseflag
      ) {
        state.timers[qid]--;

        console.log(" Timer tick:", qid, "Remaining:", state.timers[qid]);
      }
    },

    submitAnswer(state, action) {
      state.answers.push(action.payload);
      state.currentQuestionIndex++;
      if (state.currentQuestionIndex >= state.questions.length) {
        state.status = "completed";
      }
    },

    resetTimer(state, action) {
      const qid = action.payload;
      const question = state.questions.find(q => q.id === qid);
      if (question) {
        state.timers[qid] = question.timeLimit;
      }
    },

    
    pauseTimer(state) {
      state.pauseflag = true;
      console.log("Timer paused")
    },

    resumeTimer(state) {
      state.pauseflag = false;
    }
  }
});

export const {
  startSession,
  tickTimer,
  submitAnswer,
  resetTimer,
  pauseTimer,
  resumeTimer
} = sessionSlice.actions;

export default sessionSlice.reducer;
